import { render } from "./reportheadertab.vue?vue&type=template&id=ceb83e1c&scoped=true"
import script from "./reportheadertab.vue?vue&type=script&lang=js"
export * from "./reportheadertab.vue?vue&type=script&lang=js"

import "./reportheadertab.vue?vue&type=style&index=0&id=ceb83e1c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceb83e1c"]])

export default __exports__